// Friendly placeholder for shares that can't be viewed: revoked,
// expired, deleted, or never existed. Don't leak which is which to
// random URL-guessers — show a generic "unavailable" copy and tailor
// only the headline.

export function ShareUnavailable(props: {
  reason: "revoked" | "expired" | "missing" | "network";
}) {
  const headline =
    props.reason === "revoked"
      ? "This share has been revoked."
      : props.reason === "expired"
      ? "This share has expired."
      : props.reason === "network"
      ? "Couldn't load this share."
      : "This share is unavailable.";
  return (
    <div className="min-h-screen flex flex-col items-center justify-center text-center px-4 bg-white dark:bg-zinc-950 text-zinc-900 dark:text-zinc-100">
      <h1 className="text-2xl font-semibold">{headline}</h1>
      <p className="mt-2 text-sm text-zinc-500 dark:text-zinc-400">
        Ask the owner for a fresh link.
      </p>
    </div>
  );
}
